import {
    ColoursObj,
    Icon,
    Typography,
    getContrastYIQ,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useLongPress } from 'use-long-press'
import { useShallow } from 'zustand/react/shallow'
import { useDeviceInfo } from '../../../../../feat/appState/deviceInfo'
import { copyToClipboard, openBrowser } from '../../../../../utils'
/**
 * A button to open the itinerary website. Returns null if website information is unavailable.
 * @returns A button to open the itinerary website.
 */
export const WebsiteRow = ({ website }: { website: string }) => {
    const { version } = useDeviceInfo(
        useShallow((s) => {
            return { version: s.version }
        })
    )
    // Ensures an itinerary website is present.
    const longPress = useLongPress(
        () => {
            /// Long press
            copyToClipboard(website, version)
        },
        {
            threshold: 500,
            onCancel: () => {
                /// Normal press
                openBrowser(website)
            },
        }
    )

    if (!website) return null

    return (
        <Stack
            {...longPress()}
            direction="row"
            paddingTop="8px"
            paddingBottom="8px"
            justifyContent="space-between"
            width="100%"
        >
            <Stack direction="row" spacing="16px" overflow="hidden">
                <Icon
                    height="24px"
                    width="24px"
                    name={'Link'}
                    iconColour={ColoursObj.coreBrights.secondary}
                />

                <Typography
                    id="headerLabels"
                    variant="bodyRegular"
                    color={getContrastYIQ(ColoursObj.backgrounds.secondary)}
                    textOverflow="ellipsis"
                    align="left"
                    overflow="hidden"
                    whiteSpace="nowrap"
                    style={{
                        textDecoration: 'underline',
                        textUnderlineOffset: '3px',
                    }}
                >
                    {website}
                </Typography>
            </Stack>
        </Stack>
    )
}
